import type { FAQItem } from "@/lib/products";

/**
 * FAQ data for the YouTube Advanced Search Generator tool
 * Separated from view layer for maintainability
 */
export const youtubeAdvancedSearchFAQ: FAQItem[] = [
  {
    question: "How does this tool work?",
    answer:
      "The tool provides a visual interface to build complex YouTube search queries without memorizing operators. You fill in the search criteria (keywords, filters, date ranges, quality settings), and the tool generates a search query that you can copy or use directly on YouTube. It handles all the syntax and operators automatically.",
  },
  {
    question: "What filters can I use?",
    answer:
      "You can filter by upload date (last hour, today, this week, month, or year), video duration (short under 4 minutes, medium 4-20 minutes, or long over 20 minutes), video type (video, channel, playlist, or movie), and features like HD, 4K, Creative Commons, 360-degree videos, VR180, 3D, HDR, live streams, and videos with subtitles.",
  },
  {
    question: "Can I search for Creative Commons videos?",
    answer:
      "Yes! The tool includes a 'Creative Commons' filter option. When enabled, your search will only return videos licensed under Creative Commons, which you can use, share, and modify according to the license terms. This is perfect for content creators who need free-to-use video content.",
  },
  {
    question: "How do I use the generated search query?",
    answer:
      "After building your search, you can either copy the generated query to your clipboard and paste it into YouTube's search bar, or click the 'Search on YouTube' button to open YouTube directly with your filters applied. The query uses YouTube's native search syntax, so it works exactly as if you typed it manually.",
  },
  {
    question: "Can I combine multiple filters?",
    answer:
      "Yes! You can combine any filters together. For example, you can search for HD videos uploaded this week that are longer than 20 minutes and have subtitles. The tool automatically combines all your selected filters into a single search query that YouTube understands.",
  },
  {
    question: "Does this work with YouTube's actual search?",
    answer:
      "Yes. The generated queries use YouTube's native search operators and syntax. When you use the search query on YouTube, it works exactly the same as if you manually typed all the operators. The tool just makes it easier to build complex searches without memorizing the syntax.",
  },
  {
    question: "Can I save my search queries?",
    answer:
      "Currently, the tool doesn't save queries automatically, but you can copy any generated query to your clipboard and save it in a text file or notes app for later use. This is useful if you frequently search for similar types of content and want to reuse your search parameters.",
  },
  {
    question: "Is this tool free to use?",
    answer:
      "Yes, completely free with no registration required. You can use it as many times as you need to build YouTube search queries. There are no limits, no watermarks, and no hidden fees. It's part of our free tools collection to help researchers, content creators, and anyone who needs to find specific videos on YouTube.",
  },
];
